import { MESSAGE_TYPES } from "utils/helpers/enums/shared.enum";
import { PictureDTO } from "./picture.dto";
import { getFilePathWithBackendUrl } from "utils/helpers/common/http-methods";

export class MessageDTO {
    id: number;
    text: string = ''
    time: string = '';
    senderId: number;
    sentByMe: boolean = false;
    read: boolean = false;
    message: string = '';
    messageType: MESSAGE_TYPES = MESSAGE_TYPES.TEXT;
    media: PictureDTO[] = [];
    eventId: number;
    userProfilePic: string = '';
    createdAt: string = '';

    constructor(data: Partial<MessageDTO> = {}) {
        for (let key in data) {
            if (key === 'userProfilePic') {
                this[key] = getFilePathWithBackendUrl(data[key]);
            } else {
                this[key] = data[key];
            }
        }
    }
}